<p-card header="404 - Page not found">
    <div class="text-center font-bold text-5xl">
        Sorry
    </div>

    <div class="text-center text-8xl">
        ¯\_(ツ)_/¯
    </div>

    <button pButton [routerLink]="['home']">
        <icon icon="home"></icon>&nbsp;Home
    </button>
</p-card>
